import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import {Router, browserHistory} from 'react-router';
import promise from 'redux-promise';
import { ReduxRouter, reduxReactRouter  } from 'redux-router';

import routes from './routes';
import reducers from './reducers';

import './../node_modules/bootstrap/dist/css/bootstrap.css';
import './../node_modules/bootstrap-select/dist/css/bootstrap-select.min.css';
import './../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import './../node_modules/bootstrap-timepicker/css/bootstrap-timepicker.min.css';
import './../node_modules/react-summernote/dist/react-summernote.css';
import '../assets/style.css';
import './../node_modules/jquery/dist/jquery.min';
window.jQuery = window.$ =  require('jquery/dist/jquery.min');
import './../node_modules/bootstrap/dist/js/bootstrap.min';
import './../node_modules/bootstrap-select/dist/js/bootstrap-select.min';
import './../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import './../node_modules/bootstrap-timepicker/js/bootstrap-timepicker.min';
import './../node_modules/react-summernote/dist/react-summernote';
import './../node_modules/date-and-time/date-and-time.min.js';

const createStoreWithMiddleware = applyMiddleware(promise)(createStore);

ReactDOM.render(
    <Provider store={createStoreWithMiddleware(reducers, {}, window.devToolsExtension ? window.devToolsExtension() : f => f)}>
        {routes}
    </Provider>
  , document.querySelector('.wrapper'));


//, window.devToolsExtension ? window.devToolsExtension() : f => f


// WEBPACK FOOTER //
// ./src/index.js